export default class TimelineCard extends HTMLElement {
    constructor() {
        super();
    }
}

window.customElements.define('nc-timeline-card', TimelineCard);
